"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    ", "\n    /* word-break to support IE */\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Typography = (0, _styledComponents["default"])(function (_ref) {
  var disableOverflowWrap = _ref.disableOverflowWrap,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["disableOverflowWrap"]);
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], props);
})(_templateObject(), function (props) {
  return props.noWrap ? '' : 'white-space: pre-wrap;';
}, function (props) {
  return props.disableOverflowWrap ? '' : "\n        word-break: break-word;\n        overflow-wrap: anywhere;";
});
exports.Typography = Typography;